module.exports = __webpack_public_path__ + "static/media/sucess.532bfb46.svg";